/**
 *  Author: lanwei@cloudybay.com.tw
 */


(function (window, document, undefined) {


L.ShellLayer = L.Layer.extend({
    initialize: function (layer, options) {
        this._layer = layer || null;
        this._map = null;
        this.options = options || {};
    },

    puton: function(layer) {
        var self = this;
        self._layer = layer;
        if (self._layer) {
            if (self._map) {
                self._map.addLayer(self._layer);
                if (self.listens) {
                    for (var i=0; i<self.listens.length; i++) {
                        var ee = self.listens[i];
                        if (ee) {
                            self._layer.on(ee.type, ee.fn);
                        }
                    }
                }
            }
            if (self._bringToFront) {
                self._bringToFront = null;
                self._layer.bringToFront();
            }
            else if (self._bringToBack) {
                self._bringToBack = null;
                self._layer.bringToBack();
            }
        }
    },

    onAdd: function (map) {
        this._map = map;
        if (this._layer) {
            map.addLayer(this._layer);
            if (this.listens) {
                for (var i=0; i<this.listens.length; i++) {
                    var ee = this.listens[i];
                    if (ee) {
                        this._layer.on(ee.type, ee.fn);
                    }
                }
            }
        }
    },

    onRemove: function (map) {
        this._map = null;
        if (this._layer) {
            if (this.listens) {
                for (var i=0; i<this.listens.length; i++) {
                    var ee = this.listens[i];
                    if (ee) {
                        this._layer.off(ee.type, ee.fn);
                    }
                }
            }
            map.removeLayer(this._layer);
        }
    },

    addTo: function (map) {
        map.addLayer(this);
        return this;
    },

    _reset: function () {
        if (this._layer) {
            this._layer._reset();
        }
    },

    bringToFront: function () {
        if (this._layer) {
            this._layer.bringToFront();
        }
        else {
            this._bringToFront = true;
        }
        return this;
    },

    bringToBack: function () {
        if (this._layer) {
            this._layer.bringToBack();
        }
        else {
            this._bringToBack = true;
        }
        return this;
    },

    redraw: function () {
        if (this._layer) {
            this._layer.redraw();
        }
        return this;
    },

    _update: function () {
        if (this._layer) {
            this._layer._update();
        }
        return this;
    },

    instance: function() {
        return this._layer;
    },

    on: function(type, fn) {
        if (!this.listens) {
            this.listens = [];
        }
        this.listens.push({
            type: type,
            fn: fn
        });
        if (this._layer) {
            this._layer.on(type, fn);
        }
    },

    off: function(type, fn) {
        if (this.listens) {
            for (var i=this.listens.length-1; i>=0; i--) {
                var e = this.listens.length[i];
                if (e.type == type && e.fn == fn) {
                    // delete local variable is bot allowed in strict mode
                    e = null;
                    this.listens.splice(i, 1);
                }
            }
            if (this._layer) {
                this._layer.off(type, fn);
            }
        }
    }
});


}(this, document));



// WEBPACK FOOTER //
// ./src/assets/cb/leaflet/leaflet.ShellLayer.js